import { Field, FieldProps } from 'formik';
import { FormControl, InputLabel, Select, MenuItem, Box, Divider, Typography } from '@mui/material';
import { queryItemCategories } from '../schema';
import LockIcon from '@mui/icons-material/Lock';

interface Props {
    label?: string;
    required?: boolean;
    groupSystemCategories?: boolean;
}

export default function CategoryPicker({ label = 'Category', required = false, groupSystemCategories = true }: Props) {
    const { data, isLoading } = queryItemCategories();

    if (isLoading || !data) {
        return (
            <FormControl>
                <InputLabel>{label}</InputLabel>
                <Select disabled>
                    <MenuItem>Loading...</MenuItem>
                </Select>
            </FormControl>
        );
    }

    const categories = data.itemCategories || [];
    const systemCategories = categories.filter(c => c.systemDefined).sort((a, b) => (a.order || 0) - (b.order || 0));
    const userCategories = categories.filter(c => !c.systemDefined).sort((a, b) => (a.order || 0) - (b.order || 0));

    return (
        <Field name="categoryId">
            {({ field, form }: FieldProps<string>) => (
                <FormControl fullWidth required={required} error={form.touched.categoryId && Boolean(form.errors.categoryId)}>
                    <InputLabel id="category-label">{label}</InputLabel>
                    <Select
                        labelId="category-label"
                        id={field.name}
                        name={field.name}
                        label={label}
                        value={field.value || ''}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                    >
                        {groupSystemCategories &&
                            systemCategories.length > 0 &&
                            systemCategories.map(category => (
                                <MenuItem key={category.id} value={category.id}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        {category.color && (
                                            <Box
                                                sx={{
                                                    width: 16,
                                                    height: 16,
                                                    borderRadius: '50%',
                                                    backgroundColor: category.color,
                                                    border: '1px solid rgba(0,0,0,0.1)',
                                                }}
                                            />
                                        )}
                                        <Typography component="span">{category.name}</Typography>
                                        {category.systemDefined && <LockIcon sx={{ fontSize: 14, ml: 0.5, color: 'text.secondary' }} />}
                                    </Box>
                                </MenuItem>
                            ))}
                        {groupSystemCategories && systemCategories.length > 0 && userCategories.length > 0 && <Divider />}
                        {userCategories.map(category => (
                            <MenuItem key={category.id} value={category.id}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {category.color && (
                                        <Box
                                            sx={{
                                                width: 16,
                                                height: 16,
                                                borderRadius: '50%',
                                                backgroundColor: category.color,
                                                border: '1px solid rgba(0,0,0,0.1)',
                                            }}
                                        />
                                    )}
                                    <Typography component="span">{category.name}</Typography>
                                </Box>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </Field>
    );
}
